import { render, staticRenderFns } from "./DmTransactionProfileHeader.vue?vue&type=template&id=ad6ac958&scoped=true&"
import script from "./DmTransactionProfileHeader.vue?vue&type=script&lang=js&"
export * from "./DmTransactionProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./DmTransactionProfileHeader.vue?vue&type=style&index=0&id=ad6ac958&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6ac958",
  null
  
)

export default component.exports